PREFIX ccf: <http://purl.org/ccf/>
PREFIX HRApop: <https://purl.humanatlas.io/graph/hra-pop>
PREFIX UBERON: <http://purl.obolibrary.org/obo/UBERON_>
PREFIX xsd: <http://www.w3.org/2001/XMLSchema#>
PREFIX HRA: <https://purl.humanatlas.io/collection/hra-api>

SELECT ?tool ?modality ?cell_id ?cell_label (?predicted_cell_count AS ?count) (?predicted_cell_count / ?total_cell_count AS ?percentage)
FROM HRA:
FROM HRApop:
WHERE {
  {
    SELECT ?tool ?modality ?cell_id (SAMPLE(?cell_label) AS ?cell_label) (sum(?weighted_cell_count) AS ?predicted_cell_count)
    WHERE {
      #{{AS_WEIGHT_VALUES}}
      ?as ccf:has_cell_summary [ ccf:cell_annotation_method ?tool ;
           ccf:modality ?modality ;
           ccf:has_cell_summary_row [ ccf:cell_id ?cell_id ;
           ccf:cell_label ?cell_label ;
           ccf:cell_count ?cell_count ] ] .
      BIND (xsd:decimal(?cell_count) * xsd:decimal(?weight) AS ?weighted_cell_count)
    }
    GROUP BY ?tool ?modality ?cell_id
  }
  {
    SELECT ?tool ?modality (sum(?weighted_cell_count) AS ?total_cell_count)
    WHERE {
      #{{AS_WEIGHT_VALUES}}
      ?as ccf:has_cell_summary [ ccf:cell_annotation_method ?tool ;
           ccf:modality ?modality ;
           ccf:has_cell_summary_row [ ccf:cell_count ?cell_count ] ] .
      BIND (xsd:decimal(?cell_count) * xsd:decimal(?weight) AS ?weighted_cell_count)
    }
    GROUP BY ?tool ?modality
  }
}
ORDER BY ?tool ?modality ?predicted_cell_count
